import { render, staticRenderFns } from "./SecureFrame.vue?vue&type=template&id=5667f40c&"
import script from "./SecureFrame.vue?vue&type=script&lang=js&"
export * from "./SecureFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports